import {Anchor, Center, Loader, Stack, Text} from "@mantine/core";
import gt from "semver/functions/gt";
import React, {lazy, LazyExoticComponent, Suspense, useContext} from "react";
import {OmniContext} from "@/OmniContext.ts";
import {Link} from "react-router-dom";
import {modals} from "@mantine/modals";
import {RELEASE_NOTES_MODAL_ID, ReleaseNotesVersion} from "@/components/ReleaseNotesModal/modal_utils.tsx";

function VersionNotes({show, lazy}: {show: boolean, lazy: LazyExoticComponent<() => React.JSX.Element>}) {
    const LazyVersionNotes = lazy
    if (!show) return
    return <LazyVersionNotes/>
}

export default function ReleaseNotesModal({showAll}: {showAll?: boolean}) {
    const context = useContext(OmniContext)
    const lastViewedVersion = context.user?.last_viewed_version_notes
    const show = (v: ReleaseNotesVersion) => {
        return showAll || !!(lastViewedVersion && gt(v, lastViewedVersion));
    }
    if (lastViewedVersion == undefined) return
    return <Stack>
        <Text>You can review the release notes at any time by clicking the Release Notes button on the homepage. If you would like a more detailed list of changes, see the <Anchor component={Link} to={"/about"} onClick={() => modals.close(RELEASE_NOTES_MODAL_ID)}>Changelog</Anchor></Text>
        <Suspense fallback={<Center><Loader/></Center>}>
            <VersionNotes show={show(ReleaseNotesVersion._0_36_0)} lazy={lazy(() => import("./ReleaseNotes0_36_0"))}/>
            <VersionNotes show={show(ReleaseNotesVersion._0_32_0)} lazy={lazy(() => import("./ReleaseNotes0_32_0"))}/>
            <VersionNotes show={show(ReleaseNotesVersion._0_31_0)} lazy={lazy(() => import("./ReleaseNotes0_31_0"))}/>
            <VersionNotes show={show(ReleaseNotesVersion._0_30_0)} lazy={lazy(() => import("./ReleaseNotes0_30_0"))}/>
            <VersionNotes show={show(ReleaseNotesVersion._0_29_1)} lazy={lazy(() => import("./ReleaseNotes0_29_1"))}/>
            <VersionNotes show={show(ReleaseNotesVersion._0_29_0)} lazy={lazy(() => import("./ReleaseNotes0_29_0"))}/>
        </Suspense>
    </Stack>
}